import React from "react";

import { SearchBoxSelect, SearchBoxText } from "../Search";


export const SearchBoxTypes = props => {
  if (props.type === 'select') return <SearchBoxSelect {...props} />
  if (props.type === 'text') return <SearchBoxText {...props} />
  // else if (props.type === 'tab') return <FilterTabs {...props} />
  // else if (props.type === 'radio') return <FilterRadio {...props} />
  // else if (props.type === 'date') return <FilterDate {...props} />
}
